import { isEqual } from "lodash";
import { Children, memo } from "react";
import HomeSection from "../widget/HomeSection/HomeSection";
import Title from "../widget/Title/Title";
import "./Solutions.scss";
import { preStaticUrl } from "../../../../constants/env_config";
import ALink from "../../../../components/ALink/ALink";
import { useCustomTranslation } from "../../../../hooks/useCustomTranslation";
type ISolutionsItem = {
  title: string;
  content: string;
  show?: boolean;
  link?: string;
};
export const SolutionsList: ISolutionsItem[] = [
  {
    show: true,
    title: "Proof of Prompt",
    content:
      "Zypher\'s cryptographic verification protocol for prompt integrity. It enables AI agents to commit to prompts on-chain using zero-knowledge proofs, ensuring that prompts remain tamper-proof and verifiable without leaking sensitive inputs. Through standardized RESTful APIs and SDKs, Proof of Prompt provides a foundational trust interface for any AI system.",
    link: "https://wiki.zypher.network/zypher-ai-agent/zypher-ai-agent/zkprompt",
  },
  {
    show: true,
    title: "Security Browser",
    content:
      "A real-time browser designed for end users to audit AI agent interactions. It verifies the integrity of prompts and responses, displays risk labels, and flags anomalies. Users can actively contribute feedback and ratings through the embedded community trust panel, earning incentives for strengthening the AI audit network.",
    link: "https://wiki.zypher.network/",
  },
  {
    show: true,
    title: "Proof Mining",
    content:
      "Zypher\'s decentralized validation network powered by a cryptoeconomic incentive mechanism. Community-operated Prover nodes and individual users collaborate to verify agent outputs and generate scalable ZK proofs. This ensures tamper-proof AI execution without relying on centralized validators—fully aligned with Web3\'s trustless design.",
    link: "https://docs.zypher.network/mining/overview/",
  },
  {
    show: true,
    title: "Zytron Chain",
    content:
      "A gasless AI rollup chain built on BNB Chain, optimized for zero-knowledge agent computation. Zytron supports high-frequency inference, ZK proof generation, and AI-specific workloads, serving as the on-chain backbone for Proof of Prompt and Proof of Inference. With over 3 million wallets interacting in pre-mainnet, it anchors Zypher\'s scalable, decentralized infrastructure.",
    link: "/zytron",
  },
  // {
  //   show: false,
  //   title: "Ecosystem",
  //   content: "",
  //   link: "/ecosystem",
  // },
];
const Solutions = memo(() => {
  const { t } = useCustomTranslation();
  return (
    <HomeSection id="solutions" classNames="animate">
      <Title
        title={t("Our Solutions")}
        subTitles={[
          "Powering the AI-driven future, seamlessly.",
          // "Zypher revolutionizes the underlying infrastructure for on-chain trust in high performance applications operated by AI and Human. ",
          // t("catering to a global audience of 3 billion players."),
        ]}
      />
      <div className="solutions_nav">
        {SolutionsList.filter((v) => v.show).map((v) => (
          <SolutionsNavItem item={v} key={v.title} />
        ))}
      </div>
    </HomeSection>
  );
}, isEqual);
const SolutionsNavItem = memo(({ item }: { item: ISolutionsItem }) => {
  const { t } = useCustomTranslation();
  return (
    <ALink
      className="solutions_nav_item"
      href={item.link}
      target="_blank"
      rel="noreferrer"
    >
      <div className="solutions_nav_item_inner">
        <p className="solutions_title">{t(item.title === 'Security Browser' ? 'AI Security Browser' : item.title)}</p>
        <p className="solutions_content">{t(item.content)}</p>
        {item.link ? (
          <p className="solutions_more">
            {t("Learn More")}
            <img width={16} src={preStaticUrl + "/img/icon/arrow-right.svg"} />
          </p>
        ) : null}
      </div>
      <div className="background-animation" />
    </ALink>
  );
}, isEqual);

export default Solutions;
